import * as React from 'react';
export const NASvg = React.forwardRef(function NASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#F6F9FC',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M0 6h1v4a1 1 0 0 0 1 1h5v1H2a2 2 0 0 1-2-2V6Zm16 0h-1V2a1 1 0 0 0-1-1H9V0h5a2 2 0 0 1 2 2v4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 3 3 12H2a2 2 0 0 1-2-2V9l13.5-9h.5a2 2 0 0 1 2 2v1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M2.003 0A2 2 0 0 0 0 2.01V7.5L11.5 0H2.003Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M16 9.99c0 1.11-.9 2.01-1.992 2.01H5l11-7.5v5.49Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M2 2h2v2H2z',
      }),
    ),
  );
});
NASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var NA = {
  category: 'flag',
  colorable: false,
  name: 'NA',
  svg: NASvg,
};
